import { createSlice } from "@reduxjs/toolkit";
import { getSideBarNavigationList } from "./sidebarNavigationThunk";

const buildUrlMap = (data = []) => {
    const map = {};

    data.forEach((base) => {
        if (base.BaseNavigationURL && base.BaseNavigationURL !== "#") {
            map[base.BaseNavigationURL] = { type: "base", id: base.BaseNavigationId };
        }

        base.NavigationDetailsList?.forEach((nav) => {
            if (nav.NavigationURL && nav.NavigationURL !== "#") {
                map[nav.NavigationURL] = { type: "nav", id: nav.NavigationId };
            }

            nav.SubNavigationDetailsList?.forEach((sub) => {
                if (sub.SubNavigationURL) {
                    map[sub.SubNavigationURL] = { type: "sub", id: sub.SubNavigationId };
                }
            });
        });
    });

    return map;
};

const initialState = {
    loading: false,
    loaded: false,
    userNavTree: null,
    urlMap: {},
    error: null,
};

const sidebarNavigationSlice = createSlice({
    name: "sidebarNavigation",
    initialState,
    reducers: {
        clearSidebarNavigation: (state) => {
            state.userNavTree = null;
            state.loading = false;
            state.loaded = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getSideBarNavigationList.pending, (state) => {
                state.loading = true;
                state.loaded = false;
                state.error = null;
            })
            .addCase(getSideBarNavigationList.fulfilled, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.userNavTree = action.payload;
                state.urlMap = buildUrlMap(action.payload || []);
            })
            .addCase(getSideBarNavigationList.rejected, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.error = action.payload;
            });
    },
});

export const { clearSidebarNavigation } = sidebarNavigationSlice.actions;

export default sidebarNavigationSlice.reducer;
